/// <reference types="./eventGetChangelogEventsTotalCount.d.ts" />
import {} from '@dossierhq/core';
import { getEntityInfoAndAuthorize } from './eventGetChangelogEvents.js';
export async function eventGetChangelogEventsTotalCount(authorizationAdapter, databaseAdapter, context, query) {
    const entityResult = await getEntityInfoAndAuthorize(authorizationAdapter, databaseAdapter, context, query);
    if (entityResult.isError())
        return entityResult;
    return databaseAdapter.eventGetChangelogEventsTotalCount(context, query ?? {}, entityResult.value);
}
//# sourceMappingURL=eventGetChangelogEventsTotalCount.js.map